module.exports = __webpack_public_path__ + "static/media/12.cf9f504d.png";